@if (impersonationEnabled) {
  <div ngbDropdown (click)="$event.stopPropagation()" style="margin-right: 5px;">
    <a ngbDropdownToggle class="dropdown-toggle-more" role="button" aria-haspopup="true" aria-expanded="false" data-offset="10,10" (click)="dropdownToggleClick()">
      <span>{{text}}</span>
    </a>
    <div id="impersonationSelector" class="dropdown-menu scrollable-menu" ngbDropdownMenu aria-labelledby="avatar">
        <div>
            <loading-overlay [show]="loading">
              @if ((!profiles || (profiles && profiles.length == 0)) && !loading) {
                <p class="title">No existen usuarios que suplantar</p>
              }

              @for (profile of profiles; track $index) {
                <a class="dropdown-item" (click)="impersonate($event, profile)" [ngClass]="{'bold': profile.nif==null}">
                  @if (profile.nif != null) {
                    <i class="icon icon-user"></i>
                  }

                   @if (profile.nif == null) {
                    <i class="fas fa-chevron-left"></i>
                   }

                  {{profile.displayName}}
                </a>
              }
            </loading-overlay>
        </div>
    </div>
</div>
}
